namespace Areas.Eic {
    "use strict";

    export function gotoEicList() {
        location.href = "/Eic/List/InProcess";
    }



    export function gotoEditFromForm() {
        var keyId: any = $('#EicForm').dxForm('instance').option('EicId');
        if (keyId != null) {
            var linkInfo = "/EIC/Edit/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected.  Use List instead!", "warning", 2000);
        }
    }

    export function gotoReviewFromForm() {
        var keyId: any = $('#EicForm').dxForm('instance').option('EicId');
        if (keyId != null) {
            var linkInfo = "/EIC/Review/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected.  Use List instead!", "warning", 2000);
        }
    }

    export function create() {
        const form = $("#EicForm").dxForm("instance");
        const result: any = form.validate();

        let iScopeEditor: any = $('#ScopeEditor').dxHtmlEditor('instance');
        let iScope = iScopeEditor.option("value");

        if (result.isValid) {
            const newData: any = form.option("formData");
            const componentsGrid = $("#ComponentsGrid").dxDataGrid("instance");
            newData.EicComponentTypes = componentsGrid.getSelectedRowKeys();
            newData.Scope = iScope;
            sendRequest("/Eic/Create/Post", JSON.stringify(newData), "POST");
        }
    }

    export function deleteEic() {
        const verifyDelete = window.confirm("Are you sure you would like to DELETE this record?");

        if (verifyDelete) {
            const mainForm = $("#EicForm").dxForm("instance");

            const keyId: any = mainForm.option("EicId");
            if (keyId != null) {
                sendRequest(`/Eic/Edit/Delete/${keyId}`, "", "DELETE");
            }
        }
    }

    export function save() {
        const form = $("#EicForm").dxForm("instance");
        const result: any = form.validate();

        if (result.isValid) {
            const data: any = form.option("formData");
            const componentsGrid = $("#ComponentsGrid").dxDataGrid("instance");

            let iScopeEditor: any = $('#ScopeEditor').dxHtmlEditor('instance');
            let iScope = iScopeEditor.option("value");

            data.EICComponentTypes = componentsGrid.getSelectedRowKeys();
            data.Scope = iScope;

            sendRequest("/Eic/Edit/Put", JSON.stringify(data), "PUT");
        }
    }

    export function submit() {
        const form = $("#EicForm").dxForm("instance");
        const result: any = form.validate();

        if (result.isValid) {
            const data: any = form.option("formData");
            const componentsGrid = $("#ComponentsGrid").dxDataGrid("instance");

            let iScopeEditor: any = $('#ScopeEditor').dxHtmlEditor('instance');
            let iScope = iScopeEditor.option("value");

            data.EICComponentTypes = componentsGrid.getSelectedRowKeys();
            data.Scope = iScope;

            sendRequest("/Eic/Edit/Submit", JSON.stringify(data), "PUT");
        }
    }

    export function onComponentGridContentReady(e: any) {
        var eicId = e.component.option("EicId") as number;
        getEicEicComponentTypes(eicId);
    }

    export function onScopeEditorContentReady(e: any) {
        var scopeDesc = e.component.option("scopeDescription");
        e.component.option("value", scopeDesc);
    }

    export function getEicEicComponentTypes(eicId: number) {
        var componentsGrid = $("#ComponentsGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Eic/Edit/GetEicEicComponentTypes/${eicId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                componentsGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting components for EIC.", "error", 2000);
            }
        });
    }
}